module.exports = __webpack_public_path__ + "static/media/success-icon.9108d637.svg";